<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <Activity :type="type" :id="id" :isopen="isopen"></Activity>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import Activity from "@/components/activity";
export default {
  data() {
    return {
      navBlock: "活動  /  活動列表",
      navtitle: this.$route.query.pageType == "edit" ? "修改活動" : "草稿箱",
      type: this.$route.query.pageType,
      id: this.$route.query.id,
      isopen: this.$route.query.status == "1" ? 1 : 0,
    };
  },
  components: {
    NavBar,
    Activity,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/activity/editActivity.vue